import { Redirect, Route, Switch } from "react-router-dom";
import AccessHistory from "../telas/access-history/AccessHistory";
import ChangePassword from "../telas/change-password/ChangePassword";
import ClientControl from "../telas/client-control/ClientControl";
import CompanyControl from "../telas/company-control/CompanyControl";
import ErrorConsult from "../telas/error-consult/ErrorConsult";
import ErrorHistory from "../telas/error-history/ErrorHistory";
import Home from "../telas/home/Home";
import ConsultControl from "../telas/inputoutput-consult/ConsultControl";
import LabelControl from "../telas/label-priting/LabelControl";
import Login from "../telas/login/Login";
import ProductImport from "../telas/ProductImport/ProductImport";
import OutputProducts from "../telas/output-products/OutputProducts";
import ProgramaRole from "../telas/program-role/ProgramRole";
import ReceiptProducts from "../telas/receipt-products/ReceiptProducts";
import RegionControl from "../telas/region/RegionControl";
import RegisterUser from "../telas/register-user/RegisterUser";
import RelatorioEntregas from "../telas/relatorio-entregas/RelatorioEntregas";
import RoleMenu from "../telas/role-menu/RoleMenu";
import Role from "../telas/role/Role";
import StockAdjustment from "../telas/stock-adjustment/StockAdjustment";
import StockConsult from "../telas/stock-consult/StockConsult";
import StockLocationControl from "../telas/stock-location-control/StockLocationControl";
import SupplierControl from "../telas/supplier-control/SupplierControl";
import SystemParameter from "../telas/system-parameters/SystemParameter";
import { TagLayout } from "../telas/tag-layout/TagLayout";
import UserControl from "../telas/user-control/UserControl";
import Layout from "./layouts/Layout";
import { PrivateRoute } from "./PrivateRoute";
import DetentControl from "../telas/detent-control/DetentControl";
import TechLeadControl from "../telas/techlead-control/TechLeadControl";
import ManufacturerControl from "../telas/manufacturer-control/ManufacturerControl";
import ProductControl from "../telas/Product/ProductControl"
import PrintControl from "../telas/print-control/PrintControl";
import LabelScanningControl from "../telas/label-scanning/LabelScanningControl";
import PrintQueryControl from "../telas/printQuery-control/PrintQueryControl";
import { Purge } from "../telas/purge/Purge";


const Routes = () => (
    <Switch>
        <Route exact path="/">
            <Redirect to="/login" />
        </Route>

        <Route exact path="/login" component={Login} />

        <Layout>
            <PrivateRoute
                exact
                path="/home"
                component={Home}
            />

            <PrivateRoute
                exact
                path="/change-password"
                component={ChangePassword}
            />

            <PrivateRoute
                exact
                path="/userControl"
                component={UserControl}
            />

            <PrivateRoute
                exact
                path="/access-history"
                component={AccessHistory}
            />

            <PrivateRoute
                exact
                path="/register-user"
                component={RegisterUser}
            />

            <PrivateRoute
                exact
                path="/error-history"
                component={ErrorHistory}
            />

            <PrivateRoute
                exact
                path="/error-consult"
                component={ErrorConsult}
            />

            <PrivateRoute
                exact
                path="/system-parameters"
                component={SystemParameter}
            />

            <PrivateRoute
                exact
                path="/profile"
                component={Role}
            />

            <PrivateRoute
                exact
                path="/profile-menu"
                component={RoleMenu}
            />

            <PrivateRoute
                exact
                path="/program-role"
                component={ProgramaRole}
            />

            <PrivateRoute
                exact
                path="/conRelEntrega"
                component={RelatorioEntregas}
            />

            <PrivateRoute
                exact
                path="/import-product"
                component={ProductImport}
            />

            <PrivateRoute
                exact
                path="/region"
                component={RegionControl}
            />

            <PrivateRoute
                exact
                path="/client"
                component={ClientControl}
            />

            <PrivateRoute
                exact
                path="/detent"
                component={DetentControl}
            />

            <PrivateRoute
                exact
                path="/print"
                component={PrintControl}
            />

            <PrivateRoute
                exact
                path="/print-query"
                component={PrintQueryControl}
            />

            <PrivateRoute
                exact
                path="/tech-lead"
                component={TechLeadControl}
            />

            <PrivateRoute
                exact
                path="/manufacturer"
                component={ManufacturerControl}
            />

            <PrivateRoute
                exact
                path="/supplier"
                component={SupplierControl}
            />

            <PrivateRoute
                exact
                path="/company"
                component={CompanyControl}
            />

            <PrivateRoute
                exact
                path="/product"
                component={ProductControl}
            />

            <PrivateRoute
                exact
                path="/scanning"
                component={LabelScanningControl}
            />

            <PrivateRoute
                exact
                path="/stock-location"
                component={StockLocationControl}
            />

            <PrivateRoute
                exact
                path="/stock-adjustment"
                component={StockAdjustment}
            />

            <PrivateRoute
                exact
                path="/stock-consult"
                component={StockConsult}
            />

            <PrivateRoute
                exact
                path="/inputoutput-consult"
                component={ConsultControl}
            />

            <PrivateRoute
                exact
                path="/print-screen"
                component={LabelControl}
            />

            <PrivateRoute
                exact
                path="/receiving-products"
                component={ReceiptProducts}
            />

            <PrivateRoute
                exact
                path="/output-products"
                component={OutputProducts}
            />

            <PrivateRoute
                exact
                path="/tag-layout"
                component={TagLayout}
            />
            <PrivateRoute
                exact
                path="/purge"
                component={Purge}
            />

        </Layout>
    </Switch>
);

export default Routes;
